export const ANON_REJECT_CALL = '/api/external-meeting-chat/reject-call';
export const ANON_ACCEPT_CALL = '/api/external-meeting-chat/accept-call';
export const ANON_END_CALL = '/api/external-meeting-chat/end-call';
